export default "__VITE_ASSET__QZ6ziR0s__"